import { ActivityLogActions } from './actions'
import { Activity } from './types'

export interface State {
  activityLog?: Activity[]
  pending: boolean
  error: boolean
}

export const initialState: State = {
  activityLog: undefined,
  pending: true,
  error: false
}

export default (state = initialState, action: ActivityLogActions): State => {
  switch (action.type) {
    case 'activityLog.fetch':
    case 'activityLog.fetchCancel':
      return {
        ...state,
        pending: true,
        error: false,
        activityLog: undefined
      }

    case 'activityLog.fetchFail':
      return {
        ...state,
        pending: false,
        error: true
      }

    case 'activityLog.addActivity':
      let items: Activity[] = []

      if ('payload' in action) {
        items = action.payload ?? []
      }

      if (!state.activityLog) {
        return {
          ...state,
          activityLog: items
        }
      }

      return {
        ...state,
        activityLog: [...state.activityLog, ...items]
      }

    default:
      return state
  }
}
